<template>
  <div>
    <video ref="videoPlayer" class="video-js" data-setup='{"liveui": true}'></video>
  </div>
</template>

<script>
import videojs from "video.js";

export default {
  name: "VideoPlayer",
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      player: null
    };
  },
  methods: {
    disableRightClick() {
      var myVideo = document.getElementById("corsvid");
      if (myVideo.addEventListener) {
        myVideo.addEventListener('contextmenu', function(e) {
          e.preventDefault();
        }, false);
      } else {
        myVideo.attachEvent('oncontextmenu', function() {
          window.event.returnValue = false;
        });
      }
    },
  },
  mounted() {
    this.player = videojs(
      this.$refs.videoPlayer,
      this.options,
      function onPlayerReady() {}
    );
    this.disableRightClick()
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
};
</script>
